import { useCallback } from 'react';
import { AnySchema, ValidationError } from 'yup';

interface CurrentError extends ValidationError {
  path: string;
}

export const useYupValidationResolver = (validationSchema: AnySchema) =>
  useCallback(
    async (data) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (errors) {
        return {
          values: {},
          // @ts-ignore
          errors: errors.inner.reduce(
            (allErrors: ValidationError, currentError: CurrentError) => ({
              ...allErrors,
              [currentError.path]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );
